<div class="presenter-config-outer-container">
  <div class="presenter-config-container">
    <ng-content></ng-content>
  </div>
  <div class="footer-container">
    <ng-content select="[footer]"></ng-content>
  </div>
</div>
